const enum TriggerType {
    ACTIVATION = 'activation',
    CONTENT = 'content',
    TIME = 'time',
    VISIT = 'visit',
    UNKNOWN = 'unknown'
}

export default TriggerType